
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import '../plugins';

import '../../vendor/owl-carousel/owl.carousel.min.js';
import nouislider from '../../vendor/nouislider/nouislider';
import Photoswipe from '../../vendor/photoswipe/photoswipe.js';
import PhotoSwipeUI_Default from '../../vendor/photoswipe/photoswipe-ui-default.js';
import '../../vendor/select2/js/select2.min.js';

window.noUiSlider = nouislider;
window.PhotoSwipe = Photoswipe;
window.PhotoSwipeUI_Default = PhotoSwipeUI_Default;

import './core/common';
import './core/number.js';
import './core/main.js';
import './core/header.js';
import './core/cart.js';
import './core/search';

import './pages/home';
import './pages/shops';
import './pages/shops-list';
import './pages/checkout';
import './pages/address';
import './pages/card-payment';
import './pages/wishlist';
import './pages/edit-profile';
import './pages/quote';
import './pages/checkout-summary';
import './pages/quote-cart';
